<div class="card card--no-padding">
  <div class="port-services-panel__wrapper">
    <div class="port-services-panel__part">
      <div class="port-services-panel__header">
        <div class="port-services-panel__header-flex">
          <h3>{{ "Service.ActiveServices" | translate }}</h3>
          <div class="tags">
            @for (tag of tags(); track $index) {
              <div class="tag">{{ tag }}</div>
            }
          </div>
        </div>
        <div>
          <port-visualiser
            [subscription]="subscription()"
            (selected)="onClickBar($event)"
            [highlightedSubscriptionId]="activeSubscriptionId() ?? ''"
          >
          </port-visualiser>
        </div>
      </div>
      <div class="port-services-panel__list">
        @for (sub of services(); track sub.subscriptionId) {
          <service-row
            [service]="sub"
            [active]="sub.subscriptionId === activeSubscriptionId()"
            (click)="setActiveSubscription(sub)"
          />
        }
      </div>
    </div>
    <div class="port-services-panel__part port-services-panel__part--right">
      @if (activeSubscription(); as active) {
        <div class="port-services-panel__animate">
          <service-summary [service]="active" [showTraffic]="true" [vlanranges]="activeSubscriptionVlanranges()" />
        </div>
      }
    </div>
  </div>
</div>
